import config from '../config';
//import conf from '../settings.json';

// export const await BASE_URL = `${config.apiGateway.URL}:${config.service_port}`;
// temp solution for demo environment
export const MAIN_URI = window.location.hostname
export const MAIN_PROTOCOL = window.location.protocol
export const BASE_PORT = get_base_port()
export const API_V = '/api/v1';

export const AUTOMMATE_API_URL = `${config.apiGateway.AUTOMMATE_API_HOST}:${config.apiGateway.AUTOMMATE_API_PORT}${API_V}`;
// export const AUTOMMATE_API_URL = `https://betaautommate.com/api/v1`;

async function get_base_port() {
    try {
        const response = await fetch('/config/settings.json');
        const data = await response.json();
        return process.env.NODE_ENV && process.env.NODE_ENV === "development" ? 2096 : data.service_port;
    } catch (error) {
        return '2096';
    }
}

async function GET_BASE_URL() {
    //const data = window.cFileData;
    return `${MAIN_PROTOCOL}//${MAIN_URI}:${await BASE_PORT}${API_V}`;
    // return `https://betaautommate.com/api/v1`;
    // try {

    //     console.log('BASE_PORT => ', BASE_PORT)
    //     console.log('url' + `${MAIN_PROTOCOL}//${MAIN_URI}:${BASE_PORT}${API_V}`)
    //     return `${MAIN_PROTOCOL}//${MAIN_URI}:${service_port}${API_V}`;
    //     // if (data.service_port) {
    //     //     return `${MAIN_PROTOCOL}//${MAIN_URI}:${data.service_port}${API_V}`;
    //     // } else {
    //     //     console.log('url' + `${MAIN_PROTOCOL}//${MAIN_URI}:${BASE_PORT}${API_V}`)
    //     //     return `${MAIN_PROTOCOL}//${MAIN_URI}:${BASE_PORT}${API_V}`;
    //     // }
    // } catch (err) {
    //     console.log("error:=>", err);
    //     return `${MAIN_PROTOCOL}//${MAIN_URI}:${service_port}${API_V}`;
    // }

}

async function GET_BASE_ORIGIN() {
    //const data = window.cFileData;
    // return 'https://betaautommate.com';
    return `${MAIN_PROTOCOL}//${MAIN_URI}:${await BASE_PORT}`;
    // try {
    //     return `${MAIN_PROTOCOL}//${MAIN_URI}:${service_port}`;
    //     // if (data.service_port) {
    //     //     return `${MAIN_PROTOCOL}//${MAIN_URI}:${data.service_port}`;
    //     // } else {
    //     //     return `${MAIN_PROTOCOL}//${MAIN_URI}:${BASE_PORT}`;
    //     // }
    // } catch (err) {
    //     return `${MAIN_PROTOCOL}//${MAIN_URI}:${service_port}`;
    // }
}

export const BASE_URL = GET_BASE_URL();
export const BASE_ORIGIN = GET_BASE_ORIGIN();

export const ADMIN = {
    ID: '9bf95756-269c-478e-8421-8834f19dc359',
    ROLE_NAME: 'Admin',
    ROLE_ID: '63240945-f9a7-497f-a132-c0c3b7aa32c7'
};
export const GUEST = {
    ID: 'c169ef5c-3975-499c-ba5b-918c5e845b3c',
    ROLE_NAME: 'User',
    ROLE_ID: 'b99d100a-38fb-459d-aec7-29920da62562'
};
export const AUTOM_MAKER = {
    ROLE_NAME: 'Autom Maker',
    ROLE_ID: 'd9c3d601-6fb6-417e-bf8b-d5aff8922474'
};
export const IPAAS_DEV = {
    ID: 'c169ef5c-3975-499c-ba5b-918c5e845b66',
    ROLE_NAME: 'IPAAS Developer',
    ROLE_ID: '9bf95756-269c-478e-8421-8834f19dc3ta'
};
export const RPA_DEV = {
    ID: 'c169ef5c-3975-499c-ba5b-918c5e845b77',
    ROLE_NAME: 'RPA Developer',
    ROLE_ID: '9bf95756-269c-478e-8421-8834f19dc3c6'
};
export const DEPENDENT_PERMISSION = 'CONTENT.MODULE.PERMISSION.VIEW';
export const NETWORK_ERROR = { message: 'GENERAL.NETWORK-ERROR', status: false };